import { makeStyles, createStyles } from '@material-ui/core/styles';

const buttonStyle = makeStyles(() =>
  createStyles({
    button: {
      width: '100%',
      fontWeight: '600',
      fontSize: '.875rem',
      backgroundColor: '#FFD200',
      boxShadow: '0 4px 12px rgb(204 168 0 / 32%)',
      border: '0',
      padding: '12px 14px',
      color: '#1a1a1e',
      '&:hover': {
        backgroundColor: '#d9b300',
        color: '#fefefe',
      },
    },
  })
);

export default buttonStyle;
